/**
 * File: src/utils/media.js
 * Mô tả: Xử lý fallback media khi hình ảnh bị lỗi hoặc không truy cập được.
 * Liên quan: src/components/game-card.js, src/components/lightbox.js
 */

const FALLBACK_GAMING_IMAGE = 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=1000&auto=format&fit=crop';

/**
 * Gắn xử lý onerror cho phần tử ảnh để tự động chuyển sang ảnh dự phòng
 * @param {HTMLImageElement} imgElement 
 * @param {string} [fallbackUrl]
 */
export const handleImageError = (imgElement, fallbackUrl = FALLBACK_GAMING_IMAGE) => {
  if (!imgElement) return;
  imgElement.onerror = () => {
    imgElement.src = fallbackUrl;
    imgElement.onerror = null;
  };
};

/**
 * Tự động chuyển đổi URL YouTube dạng watch sang dạng embed hợp lệ
 * @param {string} url 
 * @returns {string}
 */
export const formatEmbedUrl = (url) => {
  if (!url) return '';
  if (url.includes('youtube.com/watch?v=')) {
    const videoId = url.split('v=')[1]?.split('&')[0];
    return `https://www.youtube.com/embed/${videoId}`;
  }
  return url;
};
